import balanceText from "balance-text"

balanceText('.text-balance', {watch: true});